<template>
  <v-container fluid>
    <h1>Kundeoversikt</h1>
    <v-data-table :headers="CustomerHeaders" :items="Customers" :expand="false">
      <template v-slot:items="props">
        <!-- <div>{{props.item}}</div> -->
        <tr>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.label }}</td>
          <td>{{ props.item.organisations.length }}</td>
          <td>
            <v-btn @click="props.expanded = !props.expanded">Mer info</v-btn>
            <v-btn
              :to="{
                name: 'editcustomer',
                params: { customerid: props.item.id }
              }"
              >Rediger kunde</v-btn
            >
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <table style="width: 100%;">
          <tr>
            <th style="width: 10px;" />
            <th>Sektor</th>
            <th>Virksomhet</th>
            <th>Avd. Navn</th>
            <th>Leder</th>
            <th>E-Post</th>
            <th style="width: 10px;" />
          </tr>
          <tr v-for="avd in props.item.organisations" :key="avd.id">
            <td></td>
            <td>{{ avd.sector_label }}</td>
            <td>{{ avd.area_label }}</td>
            <td>{{ avd.label }}</td>
            <td>{{ avd.level }}</td>
            <td>{{ avd.leader }}</td>
            <td>{{ avd.email }}</td>
            <td></td>
          </tr>
        </table>

        <!-- <pre>
            {{props.item}}
        </pre>-->
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions(["GET_CUSTOMERS"])
  },
  data() {
    return {
      Customers: [],
      CustomerHeaders: [
        { text: "KundeId", value: "id", sortable: true },
        { text: "Navn", value: "Label", sortable: true },
        {
          text: "Avdelinger",
          sortable: false
        },
        { sortable: false }
      ]
    };
  },
  mounted() {
    this.GET_CUSTOMERS()
      .then(resp => {
        this.Customers = resp.data.customers;
      })
      .catch(ex => {
        console.error(ex);
      });
  }
};
</script>
